import { Product } from 'src/shared/api/typing'

import { useQueryHook } from './queryHook'
import { apiGet } from '../config'
import { API_ROUTES } from '../routes'

interface IResponse {
  items: Product[]
  pagination: {
    totalCount: number
    perPage: number
    page: number
  }
}

interface IParams {
  query?: string
  page: number
  perPage: number
}

export const useGetListProducts = ({ query = '', page = 1, perPage = 20 }: IParams) => {
  const path = API_ROUTES.PRODUCTS

  const queryObject = useQueryHook({
    key: [path, query, String(page)],
    fetcherFunction: async () => {
      const params = {
        query,
        page,
        perPage,
      }

      const { data } = await apiGet<object, IResponse>({ path, params })

      return data
    },
  })

  if (queryObject.isLoading || queryObject.isError) {
    return {
      ...queryObject,
      data: null,
    }
  }

  return {
    ...queryObject,
    data: queryObject.data as IResponse | null,
  }
}
